module.exports = __webpack_public_path__ + "static/media/halloween9.b5a1715b.webp";